import React from 'react';
import PropTypes from 'prop-types';

class OwnerSearchInput extends React.Component {
    handleChange = e => {
        if (this.props.handleChange) this.props.handleChange(e);
    };

    render() {

        return (
            <span>
                        <input
                            ref={input => (this.ownerSearchInput = input)}
                            type="text"
                            name="owner-task-filter"
                            onChange={this.handleChange}
                            className="filter-input-box-category"
                            value={this.props.defaultValue}
                            placeholder={this.props.placeholderText}
                            autoFocus
                        />
             </span>
        );
    }
}

OwnerSearchInput.propTypes = {
    handleChange:       PropTypes.func.isRequired,
    defaultValue:       PropTypes.string,
    placeholderText:    PropTypes.string
};

export default OwnerSearchInput;



// WEBPACK FOOTER //
// ./src/containers/_shared/Fields/OwnerSearchInput.js